import { Nztheme } from './btn-option-extend';

export class TblBtnRowExtend{
    constructor(
        public text: string, // tên text
        public icon: string, // loại icon
        public handler: Handler, // xử lý sự kiện
        public znTheme?: Nztheme | null, // loại theme
        public className?: string | null, 
        ) {}
}
type Handler = () => void;